var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99934 16C8.10308 16 8.99839 15.1047 8.99839 14H5.00028C5.00028 15.1047 5.89559 16 6.99934 16ZM13.7303 11.3216C13.1265 10.6728 11.9968 9.69687 11.9968 6.5C11.9968 4.07188 10.2943 2.12812 7.99871 1.65125V1C7.99871 0.447812 7.55121 0 6.99934 0C6.44746 0 5.99996 0.447812 5.99996 1V1.65125C3.70434 2.12812 2.00185 4.07188 2.00185 6.5C2.00185 9.69687 0.872161 10.6728 0.268412 11.3216C0.0809125 11.5231 -0.00221228 11.7641 -0.000649781 12C0.00278771 12.5125 0.404974 13 1.00247 13H12.9962C13.5937 13 13.9962 12.5125 13.9993 12C14.0009 11.7641 13.9178 11.5228 13.7303 11.3216Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.5955b9da64abc7819c824dad88038bd9.svg";
export { ForwardRef as ReactComponent };